import { DataService } from './../../service/data/data.service';
import { Component, OnInit, EventEmitter, ElementRef ,ViewChild} from '@angular/core';
import { User } from './../../model/user';
import { AuthenticationService } from '../../service/authentication/authentication.service';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { Perfil } from '../../model/perfil';
import { UserDetails } from '../../model/userdetails';
import { ModalEnviaEmailService } from '../../modules/modals/envia-email-window';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  user: User = new User();
  show: boolean;
  mensagem: string;
  showRedefinir: boolean;
  mensagemRedefinir: string;


  constructor(private authenticationService: AuthenticationService,
    private dataService: DataService,
    private enviaEmailModalService: ModalEnviaEmailService,
    private route: Router) { }

  ngOnInit() {
    this.show = false;
    localStorage.removeItem('idUser');
  }
  public onLogin() {
    this.authenticationService.login(this.user).subscribe((res: UserDetails) => {
      if (res["statusRetorno"] > 0) {
        localStorage.setItem('idUser', JSON.stringify(res));
        this.dataService.changeUserDetails(res);
        this.route.navigate(['/home']);
        this.CarregaModulos(res);
      }
      else {
        this.show = true;
        this.mensagem = res["mensagemRetorno"];

      }
    });
  }

  public OpenModal(){
    this.enviaEmailModalService.show("Esqueci Minha Senha", "Você receberá uma mensagem em seu e-mail cadastrado. Siga as instruções para recuperar a sua senha.");
  }

  CarregaModulos(userDetails: UserDetails) {
    this.dataService.changeModules(userDetails.modulos);
  }
}
